module.exports = __webpack_public_path__ + "static/assets/e7d1afcc6b77b56f399bd4dba923435b.svg";